import { Button, Typography } from '@material-ui/core';
import { CSSProperties, memo, ReactNode, useState } from 'react';
import { MediaFileType } from 'shared/enums/MediaFileType';
import { useTheme } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
import { TypographyTooltip } from 'pages/Representatives/components/TypographyTooltip';
import { capitalizeFirstLetter } from 'shared/utils/common';
type EditProfileMediaDocumentDividerProps = {
  type: MediaFileType;
  children: ReactNode;
};

const EditProfileMediaDocumentDivider = ({ type, children }: EditProfileMediaDocumentDividerProps) => {
  const [open, setOpen] = useState<boolean>(false);

  const handleOpen = () => {
    setOpen((prev) => !prev);
  };
  const theme = useTheme();
  const isDark = theme.palette.type === 'dark';
  const headerStyle: CSSProperties = {
    borderBottom: `1px solid ${isDark ? COLORS.DARK_BORDER : COLORS.LIGHT_BORDER}`,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: '8px',
    marginBottom: 10,
  };

  return (
    <div style={{ marginTop: 20 }}>
      <header style={headerStyle}>
        <TypographyTooltip variant="subtitle1">{`Hidden ${capitalizeFirstLetter(type)}s`}</TypographyTooltip>
        <Button
          variant="text"
          style={{ background: 'transparent', fontStyle: 'italic', padding: 0 }}
          color="primary"
          onClick={handleOpen}
        >
          <TypographyTooltip variant="subtitle1">{open ? 'Hide' : 'Show'}</TypographyTooltip>
        </Button>
      </header>
      {open ? children : null}
    </div>
  );
};

export default memo(EditProfileMediaDocumentDivider);
